import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryPurchaseOrderDraftPropsBody,
  IInventoryPurchaseOrderDraftResponse,
  POStatusTypes,
} from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useLoaderActions } from "@/app/hooks/useLoaderActions";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export type POStatusUpdateAPIResponseType = {
  status: boolean;
  message: string;
};

export const useInventoryPurchaseOrderUpdateAPI = () => {
  const configuration = useConfiguration();
  const { enable, disable } = useLoaderActions("isPOStatusUpdateInProgress");
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (
      filterParams: IInventoryPurchaseOrderDraftPropsBody | null,
      ID: string,
      PO_STATUS: POStatusTypes | null,
      isTo: boolean = false,
      // A background save (invoice verification autosave): no success toast, no status-update loader.
      { silent = false }: { silent?: boolean } = {},
    ) => {
      if (!silent) enable();
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: POStatusUpdateAPIResponseType = await axios
          .put(
            `${INVENTORY_MODULE?.PURCHASE_ORDER_UPDATE?.baseURL}${ID}/${isTo ? "transfer_order_closed" : PO_STATUS}/`,
            filterParams,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IInventoryPurchaseOrderDraftResponse>) => {
            if (!silent) disable();
            if (res.data.status === true) {
              if (!silent) toast.success("PO has been updated ");
              return { status: true, message: "Updated" };
              //IF COND
            } else {
              //ELSE COND
              return { status: false, message: "PO Updation Faield" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            if (!silent) disable();
            const vv = e.response.data as any;
            captureError(e);
            return { status: false, message: vv.message };
          });
        return response;
      } catch (e: any) {
        if (!silent) disable();
        const vv = e.response.data as any;
        toast.error("Server Error: " + e.message);
        return { status: false, message: vv.message };
      }
    },
    [dispatch],
  );
  return execute;
};
